import { IconButton } from '@ironscales/design-system'

export default IconButton

export const SIZES = IconButton.SIZES
export const VARIANTS = IconButton.VARIANTS
